module.exports = __webpack_public_path__ + "media/images/shop/photo_large4-6e7c29503cc345503acfa4e8303506e3.jpg";